var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEsLint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M253.07 136.053L155.929 192.137C153.5 193.541 152.002 196.134 152 198.942V311.109C152 313.917 153.498 316.513 155.929 317.917L253.07 374.001C255.501 375.405 258.497 375.405 260.928 374.001L358.071 317.917C360.5 316.511 362 313.915 362 311.109V198.942C362 196.134 360.5 193.541 358.071 192.137L260.928 136.053C258.497 134.649 255.501 134.649 253.07 136.053Z",
    fill: "#4B32C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M392.646 43.6996L508.833 245.833C513.056 253.142 513.056 261.711 508.831 269.018L392.644 469.822C388.426 477.133 380.627 480.757 372.189 480.757H139.812C131.371 480.757 123.573 477.02 119.352 469.712L3.16534 269.235C-1.05511 261.924 -1.05511 252.698 3.16534 245.387L119.352 43.6996C123.573 36.3911 131.371 31 139.812 31H372.191C380.629 31 388.426 36.3911 392.646 43.6996ZM408.259 350.241C410.835 348.753 412.624 346.004 412.624 343.033V172.256C412.624 169.282 410.811 166.535 408.235 165.048L260.113 79.6601C257.539 78.1723 254.319 78.1723 251.745 79.6601L103.754 165.048C101.178 166.535 99.4027 169.282 99.4027 172.256V343.033C99.4027 346.006 101.204 348.753 103.778 350.241L251.889 435.629C254.463 437.114 257.688 437.114 260.262 435.629L408.259 350.241Z",
    fill: "#4B32C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsLint);
export default __webpack_public_path__ + "static/media/ESLint.27a289e4ee5d43928d63ac755fd16a94.svg";
export { ForwardRef as ReactComponent };